<template>
  <div class="commission-agent">
    <el-dialog top="10vh" title="" @open="getData" :visible.sync="comDialogVisible" width="50%"
      :before-close="handleClose">
      <div class="commission-agent-table table-region last-text-align-right">
        <div class="commission-agent-table-filter">
          <el-input placeholder="搜索代理商" v-model="searchValue">
          </el-input>
          <el-button type="primary" class="margin-left-10" @click="search">查询</el-button>
        </div>
        <el-table size="small" height="600" :data="tableData" style="width: 100%">
          <el-table-column v-for="(item, index) in tableColumn" :key="index" :prop="item.prop" :label="item.label">
          </el-table-column>
          <el-table-column label="操作" align="right" width="280">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="binding(scope)">关联</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="page.total">
        </el-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sourecList, affiliatedAgent } from '../../../../common/api';

export default {
  name: 'CommissionAgent',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    agentData: {
      type: Object,
      default: () => { }
    }
  },
  computed: {
    comDialogVisible: {
      get() {
        return this.dialogVisible;
      },
      set(value) {
        this.$emit('update:dialogVisible', value);
      }
    }
  },
  data() {
    return {
      page: {
        current: 1, // 第几页
        size: 10, // 每页显示条数
        total: 0, // 总条数
      },
      searchValue: '',
      tableData: [],
      tableColumn: [
        {
          prop: 'sourceName',
          label: '名字',
        },
        {
          prop: 'sourceCode',
          label: '编号'
        }
      ]
    }
  },
  mounted() {

  },
  methods: {
    getData() {
      sourecList({
        pageSize: this.page.size,
        pageNo: this.page.current,
        sourceName: this.searchValue
      }).then(res => {
        let { data } = res;
        this.tableData = data.records;
        this.page.total = data.total;
      }).catch(error => {
      });
    },
    handleClose() {
      this.comDialogVisible = false;
      this.searchValue = '';
    },
    handleCurrentChange(val) {
      this.page.current = val;
      this.getData();
    },
    search() {
      this.getData();
    },
    binding(scope) {
      affiliatedAgent({
        affiliatedAgentCode: scope.row.sourceCode,
        id: this.agentData.id,
      }).then(res => {
        this.$emit('bindSuccess')
        this.handleClose()
      })
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.page.current = 1;
    },
  }
}
</script>

<style scoped lang="scss">
.commission-agent {
  .commission-agent-table {
    .commission-agent-table-filter {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
    }
  }

  ::v-deep .el-table {
    &::before {
      left: 0;
      bottom: 0;
      width: 100%;
      height: 0px !important;
    }
  }

  ::v-deep .el-dialog__body {
    border-top: none !important;
  }
}
</style>